import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=5c0dcb2a"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=5c0dcb2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports